import {
    isAncillaryContentDetails,
    isMovieContentDetails,
    isTvSeriesContentDetails
} from "../../../../../../../common/types/ContentDetails";
import { ContentReferenceType } from "../../../../../../../common/types/ContentReferenceType";
import { ContentAssociationFormState } from "../../../../../../common/content/types/ContentAssociationFormState";
import { CloudFileDetails } from "../../../../CloudFileDetails";

export const mapToCloudFileContentAssociationFormState = (
    cloudFileDetails: CloudFileDetails
): ContentAssociationFormState => {
    const { content } = cloudFileDetails;

    if (!content) {
        return { contentType: undefined };
    }

    if (isMovieContentDetails(content)) {
        return {
            contentType: ContentReferenceType.Movie,
            contentId: content.movie.id,
            versionIds: content.versions.map((version) => version.id)
        };
    }

    if (isTvSeriesContentDetails(content)) {
        return {
            contentType: ContentReferenceType.TvSeries,
            contentId: content.tvSeries.id,
            episodeId: content.episode?.id,
            seasonId: content.season?.id,
            versionIds: content.versions.map((version) => version.id)
        };
    }

    if (isAncillaryContentDetails(content)) {
        return {
            contentType: ContentReferenceType.Ancillary,
            contentId: content.ancillary.id,
            airlineId: content.airline.id
        };
    }

    throw new Error("Unsupported content subtype");
};
